import type { CommissionAllocationAgreementNode } from "../allocations/types";
import type { CommissionProgramConsentNode } from "../consents/types";
import type { CommissionIngestBatchNode, CommissionIngestReviewLine } from "../ingest/types";
import type { CommissionLineNode } from "../lines/types";
import type { CommissionFundingBatchNode } from "../funding/types";
import type { CommissionReleaseBatchNode } from "../release/types";
import type { CommissionActivityEventNode } from "../history/types";
import { commissionIaaFixtures, commissionProgramConsentFixtures } from "./personGrpFixtures";
import { commissionLineFixtures } from "./lineFixtures";
import { commissionFundingBatchLineFixtures } from "./fundingFixtures";
import { commissionPayoutRunFixtures } from "./releaseFixtures";
import { commissionActivityEventFixtures } from "./historyFixtures";

export const runtimeProgramConsents: CommissionProgramConsentNode[] = [...commissionProgramConsentFixtures];
export const runtimeAllocationAgreements: CommissionAllocationAgreementNode[] = [...commissionIaaFixtures];
export const runtimeCounters = { consent: 0, ingestBatch: 0, fundingBatch: 0, releaseBatch: 0 };

export const runtimeIngestBatches: Record<string, CommissionIngestBatchNode> = {};
export const runtimeReviewLines: Record<string, CommissionIngestReviewLine[]> = {};

export const runtimeCommissionLines: CommissionLineNode[] = [...commissionLineFixtures];

export const runtimeFundingBatches: Record<string, CommissionFundingBatchNode> = {};
export const runtimeFundingBatchLines: Record<
  string,
  Array<{
    id: string;
    pgaId: string;
    personDisplayName: string;
    amountCents: number;
    fundingStatus: string;
  }>
> = { ...commissionFundingBatchLineFixtures };

export const runtimeReleaseBatches: Record<string, CommissionReleaseBatchNode> = {};
export const runtimePayoutRuns: Record<string, (typeof commissionPayoutRunFixtures)[string]> = {
  ...commissionPayoutRunFixtures
};

export const runtimeActivityEvents: CommissionActivityEventNode[] = [...commissionActivityEventFixtures];
